import { CurrencyFallback } from './CurrencyFallback';
import type { ConfigFallbackStrategy } from './types';

/**
 * The `ConfigFallbackFactory` class is responsible for providing the appropriate fallback strategy
 * based on the specified field type. It serves as a factory to create instances of fallback strategies
 * (e.g., `CurrencyFallback`) that handle default values or configurations for various field types.
 */
export class ConfigFallbackFactory {
  static getStrategy(fieldType: string): ConfigFallbackStrategy | undefined {
    switch (fieldType) {
      case 'Currency':
      case 'Decimal':
      case 'Integer':
      case 'Percentage':
        return new CurrencyFallback(fieldType);
      default:
        return undefined;
    }
  }
}
